import React from "react"

const CallItem = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      id="Capa_1"
      x="0px"
      y="0px"
      viewBox="0 0 202.6 202.6"
      height="13px"
      fill="#ffffff"
    >
      <g>
        <g>
          <path d="M198,160.1l-31.3-31.3c-6.2-6.2-16.6-6-23,0.4L128,145c-1-0.6-2-1.1-3.1-1.7c-10-5.5-23.6-13.1-37.9-27.4    c-14.4-14.4-21.9-28-27.5-38c-0.6-1.1-1.1-2.1-1.7-3l10.6-10.6l5.2-5.2c6.5-6.5,6.6-16.8,0.4-23L42.7,4.8c-6.2-6.2-16.5-6-23,0.4    l-8.8,8.9l0.2,0.2c-3,3.8-5.4,8.1-7.3,12.8c-1.7,4.5-2.8,8.7-3.2,13c-4.1,34.3,11.5,65.6,54,108c58.7,58.7,106,54.3,108.1,54.1    c4.4-0.5,8.7-1.6,13-3.3c4.7-1.8,9-4.3,12.8-7.2l0.2,0.2l8.9-8.7C204.1,176.7,204.3,166.3,198,160.1z M190.7,176.2l-3.9,3.9    l-1.6,1.5c-2.5,2.4-6.7,5.7-13,8.2c-3.5,1.4-7,2.2-10.6,2.7c-0.4,0-44.9,3.8-100-51.2C14.7,94.4,7.2,67.4,10.4,41.3    c0.4-3.5,1.3-7,2.7-10.6c2.5-6.3,5.8-10.5,8.2-13l5.4-5.5c2.6-2.6,6.7-2.8,9.1-0.4L67.1,43c2.4,2.4,2.2,6.5-0.4,9.1L45.5,73.2    l2,3.3c1.1,1.8,2.2,3.9,3.5,6.1c5.8,10.5,13.8,24.8,29.1,40.2c15.3,15.3,29.6,23.3,40.1,29.1c2.3,1.2,4.3,2.4,6.2,3.5l3.3,1.9    l21.1-21.1c2.6-2.6,6.7-2.8,9.1-0.4l31.3,31.3C193.5,169.4,193.3,173.5,190.7,176.2z" />
        </g>
      </g>
    </svg>
  )
}

export default CallItem
